class PageHead extends HTMLElement {
  connectedCallback() {
    const title = this.getAttribute('title') || 'DAMMI.LV - Process Optimization Architects';
    const description = this.getAttribute('description') || 'DAMMI.LV transforms businesses through digitalization, automation, and AI.';
    const keywords = this.getAttribute('keywords') || 'business transformation, digitalization, automation, artificial intelligence';
    const ogTitle = this.getAttribute('og-title') || title;
    const ogDescription = this.getAttribute('og-description') || description;
    const ogUrl = this.getAttribute('og-url') || 'https://dammi.lv';
    const canonical = this.getAttribute('canonical') || ogUrl;
    
    // Create head elements
    const headContent = `
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${title}</title>
      
      <!-- SEO Meta Tags -->
      <meta name="description" content="${description}">
      <meta name="keywords" content="${keywords}">
      <meta name="author" content="DAMMI.LV">
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1">
      <meta name="language" content="English">
      <meta name="revisit-after" content="7 days">

      <!-- Open Graph Tags -->
      <meta property="og:type" content="website">
      <meta property="og:title" content="${ogTitle}">
      <meta property="og:description" content="${ogDescription}">
      <meta property="og:url" content="${ogUrl}">
      <meta property="og:site_name" content="DAMMI.LV">
      <meta property="og:image" content="https://dammi.lv/assets/dammi-logo.svg">
      <meta property="og:image:alt" content="DAMMI.LV Logo">

      <!-- Twitter Card Tags -->
      <meta name="twitter:card" content="summary_large_image">
      <meta name="twitter:title" content="${ogTitle}">
      <meta name="twitter:description" content="${ogDescription}">
      <meta name="twitter:image" content="https://dammi.lv/assets/dammi-logo.svg">

      <!-- Additional SEO Tags -->
      <meta name="theme-color" content="#667eea">
      <link rel="canonical" href="${canonical}">
      <link rel="alternate" hreflang="en" href="${ogUrl}?lang=en">
      <link rel="alternate" hreflang="lv" href="${ogUrl}?lang=lv">
      <link rel="alternate" hreflang="it" href="${ogUrl}?lang=it">
      <link rel="alternate" hreflang="x-default" href="${ogUrl}">

      <!-- Favicon -->
      <link rel="icon" type="image/svg+xml" href="assets/dammi-logo.svg">
      <link rel="icon" type="image/png" href="assets/dammi-logo.png">
      <link rel="apple-touch-icon" href="assets/dammi-logo.png">
      <link rel="shortcut icon" href="assets/dammi-logo.png">

      <!-- Tailwind CSS -->
      <link rel="stylesheet" href="styles/output.css">

      <!-- Fonts -->
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap" rel="stylesheet">
    `;

    // Insert into document head
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = headContent;
    
    Array.from(tempDiv.children).forEach(child => {
      document.head.appendChild(child);
    });

    // Remove this element from DOM as it's not needed anymore
    this.remove();
  }
}

customElements.define('page-head', PageHead);

